import * as modal from "../util/modal.ts";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import MultiplexApi from "../server/MultiplexApi.ts";
import * as FeatureSeen from "../util/FeatureSeen.ts";

import * as actionMenu from "../widget/action-menu-registry.ts"
import Icons from "../svg/Icons.ts";
import { notadminmodal } from "../global_connected.ts";

actionMenu.register({
  aiinboxmenu(){
    return {menu:[{svg:Icons.ic_delete, i18nkey:"aiinbox.delete",color:"var(--red)",onclick:FwDatas.getUser().isAdmin?'aiinboxdelete':'notadminmodal'}]}
  }
})

Html.registerDom({
  async aiinboxcopy(){
    navigator.clipboard.writeText(this.innerText)
    modal.toast({text:"aiinbox.copied",svg:Icons.ic_done})
  },
  async aiinboxedit(){
    if (!FwDatas.getUser().isAdmin) {
      notadminmodal()
      return;
    }
    modal.closeDomModal()
    var datas = await MultiplexApi.settingsaiinboxcheck(undefined);
    var TPL = await import("./aiinbox_modal_edit.mustache")
    modal.openDomModal(TPL,datas)
  },
  async aiinboxsave(){
    var form = this.closest('form') as HTMLFormElement;
    try{
      var datas = await MultiplexApi.settingsaiinboxsave(form.email.value );
      if(datas.available){
        var TPL = await import("./aiinbox_modal.mustache")
        modal.closeDomModal()
        modal.openDomModal(TPL,datas)
        modal.toast({text:'aiinbox.updated',svg:Icons.ic_done})
      }else{
        modal.toast({text:'aiinbox.error_already_taken',svg:Icons.ic_error})
      }
    }catch(e){
      modal.toast({text:'aiinbox.error_invalid_format',svg:Icons.ic_error})
    }
  },
  async aiinboxlearnmore(){
    var
      datas = await MultiplexApi.settingsaiinboxcheck(undefined),
      familyCalendarEmail = datas.current?datas.current+'@'+datas.domain:undefined,
      userAccountEmail = FwDatas.getUser().identifiers.filter(id=>id.type==='Email')[0]?.value;

    var domModal = modal.openDomModal(await import('./aiinbox_explain.mustache'),{
      familyCalendarEmail,
      userAccountEmail
    }), pane = domModal.querySelector('.pane-right')

    setTimeout(()=>pane?.classList.add('open'),33)
  },
  aiinboxmodal,
  aiinboxdelete,
  aiimportemail
})

/**
 * The Email button of Quick Add (FWWEB-1851): a gateway to the email import, not a new parse. The paywall for the
 * free members, the address with its copy when it exists, else the activation dialog whose create button is
 * refused to the non admin members by aiinboxedit.
 */
async function aiimportemail(this :HTMLElement){
  const fromModal = this?.closest?.('.modal-container') as modal.DomModal;
  if(fromModal) modal.closeDomModal(fromModal);
  if(FwDatas.getPermission('aiImport')!=='OK'){
    Html.trigger(null,'takepremium',['aiimport']);
    return;
  }
  const datas = await MultiplexApi.settingsaiinboxcheck(undefined);
  if(datas.current){
    aiinboxmodal();
    return;
  }
  modal.ask({
    cover:"/images/illustration_email_event_import.svg",
    h2:"aiinboxnewfeature.title",
    sub1:"aiinboxnewfeature.message",
    button:[
      {title:"aiinbox.create",action:"aiinboxedit"},
      {title:"actions.later",action:"modalclose",class:"secondary"}
    ]
  });
}


async function aiinboxmodal(){
  var datas = await MultiplexApi.settingsaiinboxcheck(undefined);
  var TPL = await import("./aiinbox_modal.mustache")
  modal.openDomModal(TPL,datas)
}
async function aiinboxdelete(){
  if(await modal.confirmDelete({
    title:"aiinbox.deletetitle",
    message:"aiinbox.deletedescription",
    yes:"aiinbox.deleteaddress"
  })){
    modal.closeDomModal();
    await MultiplexApi.settingsaiinboxsave(undefined);
    modal.toastDone('aiinbox.deleted')
  }
}
export async function displayAiInboxFeatureIfNeeded(){
  if(!FeatureSeen.hasSeen('calendar.aiimport')){
    FeatureSeen.markSeen('calendar.aiimport');
    var askinput : modal.AskInput = {
      cover:"/images/illustration_email_event_import.svg",
      h2:"aiinboxnewfeature.title",
      sub1:"aiinboxnewfeature.message",
      button:[
        {title:"actions.later",action:"modalclose",class:"secondary"},
      ]
    }
    switch(FwDatas.getPermission('aiImport')){
      case "KO_HIDE":
        return;
      case "KO_PREMIUM":
        askinput.button.unshift({title:"actions.gopremium",action:"takepremium",class:"premium"});
        break;
      case "OK":
        askinput.button.unshift({title:"aiinbox.create",action:"aiinboxedit"});
        break;
    }
    modal.ask(askinput)
  }
}
//aiinboxmodal()